import { FunctionComponent, useMemo } from "react";

type Props = {
  radios: any;
  value?: string | number;
  onChange?: (e: React.FormEvent<HTMLInputElement>, option?: any) => void;
  name: string;
  renderContent: any;
  errorMsg?: string;
  optionClassName?: string;
  wrapperClassName?: string;
  onClickSelected?: () => void;
};

export const CardRadioGroup: FunctionComponent<Props> = ({
  radios,
  value = "",
  onChange,
  name,
  renderContent,
  errorMsg = "",
  wrapperClassName = "",
  optionClassName = "",
  onClickSelected = () => {},
}) => {
  const options = useMemo(() => {
    return radios.map((option: any) => {
      return {
        ...option,
      };
    });
  }, [radios]);

  return (
    <>
      <div className={`flex ${wrapperClassName}`}>
        {options &&
          options.map((option: { value?: string; name: string }) => {
            const isSelected = option.value == value || option.name == value;
            const id = option.name || `${name}-${option.value}`;
            return (
              <div
                className={`rounded-xl transition-all ${optionClassName}`}
                key={option.name + option.value}
                style={{
                  border: `2px solid ${isSelected ? "#358639" : "#d1d5db"}`,
                  backgroundColor: isSelected ? "#f0f9f1" : "#ffffff",
                  boxShadow: isSelected ? "0 4px 12px rgba(53,134,57,0.12)" : "0 1px 2px rgba(0,0,0,0.04)",
                }}
              >
                <input
                  type="radio"
                  name={name}
                  id={id}
                  onClick={(e) => {
                    if (isSelected) {
                      onClickSelected();
                    } else {
                      onChange && onChange(e, option);
                    }
                  }}
                  value={option.value || option.name}
                  className="invisible h-0 absolute"
                />
                <label htmlFor={id} className="cursor-pointer">
                  {renderContent(option)}
                </label>
              </div>
            );
          })}
      </div>
      {errorMsg ? <p className="mt-1 text-xs text-left" style={{ color: "#dc2626" }}>{errorMsg}</p> : null}
    </>
  );
};
